import { Routes } from '@angular/router';
import { App } from './app';
import { authGuard } from './features/auth/auth.guard';
import { NotFoundComponent } from './core/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    component: App,
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home').then((c) => c.Home),
      },
      {
        path: 'portal',
        loadChildren: () =>
          import('./features/portal/portal-module').then((m) => m.PortalModule),
        canActivate: [authGuard],
      },
      {
        path: 'public',
        loadChildren: () =>
          import('./features/public/public-module').then((m) => m.PublicModule),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },
];
